<style  scoped></style>
<template>
  <div class="c-page u-relative">
  <section    data-color="clear" class="u-relative u-fit-w u-bg--brand-dark u-overflow-h js-header-panel">
          <div class="c-page__header o-wrapper--panel" :style="myStylesTransform2">
            <img  :src="imageHeadSrc" class="u-absolute u-pos-tl"  :style="myStylesWidthHeight">
          </div>
          <div class="o-wrapper--valign u-viewport-fit-h u-fit-w">
              <div class="u-relative u-inline-block u-valign-bottom u-marg-l-w1of12 u-marg-b-vh1of12 u-marg-b-vh3of12@sm">
                <span class="c-page__subtitle t-h2 t-text--roman u-color--white u-inline-block u-marg-b-md" v-html="content.subtitle"></span>
                  <h1 class="t-h2-sub  t-text-lh--md u-color--white u-marg-b-lg">
                      <app-sliced-text :content="content.title"></app-sliced-text>
                  </h1>
                </div>
          </div>
      </section>
      <section data-color="dark" class="u-relative u-fit-w  u-overflow-h js-header-panel">
    <!--<div  class="u-absolute u-pos-tl u-fit" >
       <div class="c-investors__section-2__pattern u-absolute u-pos-tl  u-marg-t-xl   u-marg-l-xxl   u-marg-l-lg@md  u-marg-l-sm@sm c-firstslide__whoweare__logo u-w2of10 u-marg-b-0@sm ">
         <img src="../../assets/medias/images/lgoRghPart.svg" class="u-fit-w">
       </div>
        <div class="c-investors__section-2__pattern u-absolute u-pos-bl u-w2of10 u-marg-b-0@sm">
          <img src="../../assets/medias/images/ContactUpImage.png" class="u-fit-w">
        </div>
      </div>-->
   <div class="u-relative u-fit-w">
      <div class="u-flex u-flex-fd--column@sm  u-align-left u-pad-y-xxl u-pad-x-w2of12">
        <app-scroll-object   :offset="0"   :isParallax="!1" inline-template  :content="content" >
          <div class="w2of10 u-w1of3@md u-fit-w@sm">
           <h3 class="t-h3 t-text--roman u-relative u-marg-r-lg u-marg-r-0@sm u-color--gray" >
              <img src="../../assets/medias/images/lgoRghPart.svg" class="c-logo-Sector-offset2 c-investors__section-2__pattern c-firstslide__whoweare__logo  u-absolute u-pos-bl" >
                <span class="c-number-offset2 t-text--xl--Light u-absolute u-pos-bl" >01</span>
               <app-words  :isActive="isActive" :delay="0" :content="content.second_block_title"></app-words>
             </h3>
         </div>
       </app-scroll-object>
         <div class="c-contact__section__location__details  u-flex u-w5of8 u-fit-w">
            <div class="u-marg-t-md u-fit-w t-text--xl t-text-lh--lg u-color--gray">
               <div class="u-w2of2" :key="index"  v-for="(postal, index)  in content.postal_addresses"  >
                   <app-scroll-object   :offset="0"   :isParallax="!1" inline-template  :content="postal" >
                     <app-words  :isActive="isActive" :delay="0" :content="content.name"></app-words>
                    </app-scroll-object>
                </div>
            </div>
            <div class="u-marg-b-md u-flex u-fit-w">
               <address class="u-w2of2 t-address t-text--md u-color--gray" :key="index"  v-for="(postal, index)  in content.postal_addresses" v-html="postal.address"></address>
            </div>
            <div class="u-fit-w">
               <ul class="o-list u-w2of2" v-for="(postal, index)  in content.postal_addresses"  >
                 <li  v-if="postal.view_on_phone">
                   <a href="#" target="_blank" rel="noopener nofollow noreferrer" class="c-contact__section__location__details__map-link u-color--gray">
                     <img src="../../assets/medias/images/icons/phone.svg" class="t-icon--phone u-inline-block u-valign-middle u-marg-r-sm">
                      <span class="t-text--md u-color--gray u-inline-block u-valign-middle" v-html="postal.phone_number"></span>
                    </a>
                  </li>
                 <li v-if="postal.view_on_email" class="u-marg-t-xs">
                   <a href="#" target="_blank" rel="noopener nofollow noreferrer" class="c-contact__section__location__details__map-link u-color--gray">
                     <img src="../../assets/medias/images/icons/email-black.svg" class="t-icon--pin u-inline-block u-valign-middle u-marg-r-sm">
                     <span class="t-text--md u-inline-block u-valign-middle" v-html="postal.email"></span>
                   </a>
                 </li>
                  <li v-if="postal.view_on_map" class="u-marg-t-xs">
                    <a :href="_getGoogleMapUrl(postal.map_address)" target="_blank" rel="noopener nofollow noreferrer" class="c-contact__section__location__details__map-link u-color--gray">
                      <img src="../../assets/medias/images/icons/pin.svg" class="t-icon--pin u-inline-block u-valign-middle u-marg-r-sm">
                      <span class="t-text--md u-inline-block u-valign-middle" v-html="content.label_view_on_map"></span>
                    </a>
                  </li>
                  <li v-if="postal.view_on_map" class="u-marg-t-sm shareBtn facebook" style="margin-top:30px" >
                    <a href="https://www.facebook.com/ResourceGroupHolding/" target="_blank" rel="noopener nofollow noreferrer" class="c-contact__section__location__details__map-link u-color--gray">
                      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 38" fill="#000000">
                                   <path opacity="0.5" d="M19,38C8.514,38,0,29.486,0,19C0,8.514,8.514,0,19,0c10.486,0,19,8.514,19,19C38,29.486,29.486,38,19,38z M19,1.443C9.332,1.443,1.443,9.332,1.443,19c0,9.669,7.889,17.557,17.557,17.557c9.669,0,17.557-7.888,17.557-17.557 C36.557,9.332,28.668,1.443,19,1.443z"></path>
                                   <path d="M19.674,26.023v-6.832h2.309l0.336-2.646h-2.646v-1.684c0-0.771,0.19-1.299,1.298-1.299 h1.396v-2.404c-0.241-0.049-1.06-0.097-2.068-0.097c-2.021,0-3.416,1.251-3.416,3.512v1.973H14.62v2.646h2.309v6.831H19.674 L19.674,26.023z"></path>
                         </svg>
                        </a>
                        <a href="https://www.linkedin.com/company/resource-group-holding-sal/" target="_blank" rel="noopener nofollow noreferrer" class="c-contact__section__location__details__map-link u-color--gray">
                          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="-680 490 38 38" fill="#000000">
                                      <path opacity="0.5" d="M-661,528c-10.486,0-19-8.514-19-19s8.514-19,19-19c10.486,0,19,8.514,19,19S-650.514,528-661,528z M-661,491.443c-9.668,0-17.557,7.889-17.557,17.557c0,9.669,7.889,17.557,17.557,17.557c9.669,0,17.557-7.888,17.557-17.557 C-643.443,499.332-651.332,491.443-661,491.443z"></path>
                                      <rect x="-668.937" y="504.671" width="3.463" height="10.968"></rect>
                                      <path d="M-656.046,504.526c-1.972,0-3.222,1.059-3.462,1.828v-1.731h-3.897c0.048,0.913,0,10.967,0,10.967h3.897 v-5.916c0-0.338,0-0.674,0.096-0.914c0.289-0.674,0.818-1.348,1.875-1.348c1.347,0,1.973,1.012,1.973,2.502v5.676h3.944v-6.109 C-651.668,506.113-653.592,504.526-656.046,504.526z"></path>
                                      <path d="M-667.301,499.476c-1.299,0-2.117,0.817-2.117,1.924c0,1.059,0.818,1.876,2.068,1.876h0.048 c1.299,0,2.116-0.817,2.116-1.924C-665.233,500.293-666.002,499.476-667.301,499.476z"></path>
                                  </svg>
                            <span class="t-text--md u-inline-block u-valign-middle  u-marg-l-xs" ></span>
                        </a>

                  </li>
                  <li v-if="postal.view_on_map" class="u-marg-t-xs shareBtn twitter" >

                  </li>
               </ul>
            </div>
         </div>

      </div>
   </div>
</section>
  <app-footer :globalContent="globalContent" :adminContent="adminContent"  :newsletterShown="!0"></app-footer>
  </div>

</template>

<script>
import AppFooter from '../app-footer/index.vue'
import AppScrollObject from '../app-scroll-object/index.vue'
import AppSlicedText from '../app-sliced-text/index.vue'
export default {
    components: {
      "app-sliced-text":AppSlicedText,
      "app-footer":AppFooter,
      "app-scroll-object":AppScrollObject
    },
    props: {
        adminContent: {
            type: Object,
            default: function() {}
        },
        globalContent: {
            type: Object,
            default: function() {}
        },
        headerPageSize: {
            type: Array,
            default: function() {}
        }
    },
    computed: {
        content: function() {
            return this.adminContent.en.pages.contact

        }
        ,
        myStylesTransform2() {
          return {
              transform: 'translateX('+this.headerPageSize[2]+'px) translateY('+this.headerPageSize[3]+'px) scale('+this.headerPageSize[4]+')'

          }

      },
      myStylesWidthHeight() {
         return {
           width: this.headerPageSize[0] + "px",
           height: this.headerPageSize[1] + "px"

         }
     }
    },
    created: function() {
        this.GOOGLE_API_URL = "https://www.google.com/maps/search/?api=1&query=:address",
            this.onResize = this.onResize.bind(this),
            this.eventHub.$on("resize", this.onResize)
    },
    destroyed: function() {
        this.eventHub.$off("resize", this.onResize)
    },
    mounted: function() {
        this.eventHub.$emit("page:ready"),
        this.onResize()
    },
    data: function() {
        return {

          imageHeadSrc:require('../../assets/medias/images/Contact-Header-Rgh.jpg')

        }
      },
    methods: {
        onResize: function() {},
        _getGoogleMapUrl: function(t) {
          return  "https://drive.google.com/open?id=1L0EorG9WxDMEQx055BjFMkFD3yp_E8mE&usp=sharing"
            //return this.GOOGLE_API_URL.replace(":address", encodeURIComponent(t.replace("<br />", " ").replace("\n", "")))
        }
    }
}

</script>



// WEBPACK FOOTER //
// src/components/app-page-contact/index.vue